import {Injectable} from '@angular/core';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {NzNotificationDataOptions} from 'ng-zorro-antd/notification/typings';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class NotificationService {

    constructor(
        private notification: NzNotificationService,
        private translateService: TranslateService
    ) {
    }

    error(content: string, options?: NzNotificationDataOptions) {
        return this.notification.create(
            'warning',
            '',
            content ? this.translateService.instant(content) : '',
            {
                nzDuration: 3000,
                nzPauseOnHover: true,
                nzClass: 'notification--error',
                ...options
            }
        );
    }

    success(content: string, options?: NzNotificationDataOptions) {
        return this.notification.create(
            'success',
            '',
            content ? this.translateService.instant(content) : '',
            {
                nzDuration: 3000,
                nzPauseOnHover: true,
                ...options
            }
        );
    }

}
